/**
 * @generated SignedSource<<cc07d74c3e9858317577b102bbbd43c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type hooksAuthorAndTopicNameQuery$variables = {
  entityUuid: string;
  fetchAuthor: boolean;
  fetchTopic: boolean;
};
export type hooksAuthorAndTopicNameQuery$data = {
  readonly author?: {
    readonly urlAlias: string;
  };
  readonly topic?: {
    readonly urlAlias: string;
  };
};
export type hooksAuthorAndTopicNameQuery = {
  response: hooksAuthorAndTopicNameQuery$data;
  variables: hooksAuthorAndTopicNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityUuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchAuthor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchTopic"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityUuid",
        "variableName": "entityUuid"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksAuthorAndTopicNameQuery",
    "selections": [
      {
        "condition": "fetchAuthor",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Author",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "fetchTopic",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hooksAuthorAndTopicNameQuery",
    "selections": [
      {
        "condition": "fetchAuthor",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Author",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "fetchTopic",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b1aac536bdb12b680b9b7c730cab2d91",
    "id": null,
    "metadata": {},
    "name": "hooksAuthorAndTopicNameQuery",
    "operationKind": "query",
    "text": "query hooksAuthorAndTopicNameQuery(\n  $entityUuid: String!\n  $fetchAuthor: Boolean!\n  $fetchTopic: Boolean!\n) {\n  author(filter: {entityUuid: $entityUuid}) @include(if: $fetchAuthor) {\n    urlAlias\n    id\n  }\n  topic(filter: {entityUuid: $entityUuid}) @include(if: $fetchTopic) {\n    urlAlias\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "358535e1a7b4b387c305ca075761164b";

export default node;
